import kebabCase from 'hs-lodash/kebabCase';
import { CompanySizeOption } from 'signup-constants/signupData/CompanySizeOption';
import { Data } from '../signup-data/DATA';
import { getSignupDataValue } from '../store/signup-data/selectors';
export const checkCompanySizeIsLessThan5 = companySize => {
  return companySize === CompanySizeOption.One || companySize === CompanySizeOption.TwoToFive;
};
export const cmsFreeOptionalDomain = '-hubspot-freecmstools.com';
let timestampUsedForOptionalDomain;
export const setTimestampUsedForOptionalDomain = timestamp => {
  timestampUsedForOptionalDomain = timestamp;
};
export const getPresetOptionalDomain = companyName => {
  let cleanedCompanyName = kebabCase(companyName);

  if (!cleanedCompanyName) {
    const timestamp = timestampUsedForOptionalDomain || Date.now();
    setTimestampUsedForOptionalDomain(timestamp);
    cleanedCompanyName = `${timestamp}`;
  }

  return `${cleanedCompanyName}${cmsFreeOptionalDomain}`;
};
export const hasPresetOptionalDomain = state => {
  const companyName = getSignupDataValue(state, Data.CompanyName);
  const companyDomain = getSignupDataValue(state, Data.CompanyDomain);
  const optionalDomain = getPresetOptionalDomain(companyName);
  return optionalDomain === companyDomain;
};